import { render, staticRenderFns } from "./profileBuIujptl.vue?vue&type=template&id=36770c7f&scoped=true&"
import script from "./profileBuIujptl.vue?vue&type=script&lang=js&"
export * from "./profileBuIujptl.vue?vue&type=script&lang=js&"
import style0 from "./profileBuIujptl.vue?vue&type=style&index=0&id=36770c7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36770c7f",
  null
  
)

export default component.exports